import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { Label } from '@/components/ui/label';
import { RadioGroupItem } from '@/components/ui/radio-group';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
type RadioOptionProps = {
  value: string;
  id: string;
  label: ReactNode;
  disabled?: boolean;
};
export function RadioOption(t0) {
  const $ = _c(25);
  const {
    value,
    id,
    label,
    disabled
  } = t0;
  const t1 = disabled && "opacity-50";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("group flex items-center space-x-2", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== disabled || $[3] !== id || $[4] !== value) {
    t3 = <RadioGroupItem value={value} id={id} className="[&[data-state=checked]~label]:text-zinc-50" disabled={disabled} />;
    $[2] = disabled;
    $[3] = id;
    $[4] = value;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = disabled && "cursor-not-allowed";
  let t5;
  if ($[6] !== t4) {
    t5 = cn("cursor-pointer text-sm font-normal text-zinc-200 group-hover:text-zinc-50", t4);
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== id || $[9] !== label || $[10] !== t5) {
    t6 = <Label htmlFor={id} className={t5}>{label}</Label>;
    $[8] = id;
    $[9] = label;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t6) {
    t7 = <div className={t2}>{t3}{t6}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const option = t7;
  if (disabled) {
    let t8;
    if ($[16] !== option) {
      t8 = <TooltipTrigger asChild={true}>{option}</TooltipTrigger>;
      $[16] = option;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    let t9;
    if ($[18] !== label) {
      t9 = typeof label === "string" ? label.toLowerCase() : " perform this action";
      $[18] = label;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    let t10;
    if ($[20] !== t9) {
      t10 = <TooltipContent>You can't{t9} your own PR</TooltipContent>;
      $[20] = t9;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
      t11 = <TooltipProvider><Tooltip>{t8}{t10}</Tooltip></TooltipProvider>;
      $[22] = t10;
      $[23] = t8;
      $[24] = t11;
    } else {
      t11 = $[24];
    }
    return t11;
  }
  return option;
}